import { useAuth } from '../../auth/useAuth';
import { useEffect, useRef, useState } from 'preact/hooks';
import { authOrganizationApi } from '@/api/authOrganization';
export function useSignInLogic() {
    const assetsBaseUrl = import.meta.env.VITE_ASSETS_BASE_URL;
    const logoUrl = `${assetsBaseUrl}/assets/white-orbital-x.png`;
    const logoColorUrl = `${assetsBaseUrl}/assets/orbital-x-logo.png`;
    const { login, isAuth0Ready } = useAuth();
    const loginRef = useRef(login);
    loginRef.current = login;
    const startedRef = useRef(false);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorModalConfig, setErrorModalConfig] = useState(null);
    // Auto-start login when an invitation link is opened to avoid losing params on reroute
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hasInvitation = !!urlParams.get('invitation');
        const hasOrganization = !!urlParams.get('organization');
        if ((hasInvitation || hasOrganization) && !startedRef.current && isAuth0Ready) {
            startedRef.current = true;
            const invitationParams = {
                invitation: urlParams.get('invitation') || undefined,
                organization: urlParams.get('organization') || undefined,
                organization_name: urlParams.get('organization_name') || undefined,
                login_hint: urlParams.get('email') || undefined
            };
            loginRef.current(invitationParams).catch(() => {
                startedRef.current = false;
            });
        }
    }, [isAuth0Ready]);
    const GENERIC_ERROR = {
        title: 'Something Went Wrong',
        message: 'We encountered an error processing your request. Please try again later.'
    };
    const showError = (config) => {
        setErrorModalConfig(config);
        setShowErrorModal(true);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsSubmitting(true);
        try {
            const trimmed = email.trim();
            if (!trimmed) {
                setError('Email is required');
                setIsSubmitting(false);
                return;
            }
            const resp = await authOrganizationApi.getOrgIdByEmail(trimmed);
            if (resp.status === 404) {
                showError({
                    title: 'Domain Not Found',
                    message: "It doesn't look like your company is registered with us yet. If you think this is an error, please reach out to our support team for assistance."
                });
                setIsSubmitting(false);
                return;
            }
            if (resp.error || resp.status !== 200) {
                showError(GENERIC_ERROR);
                setIsSubmitting(false);
                return;
            }
            let orgId;
            if (resp.data) {
                orgId = String(resp.data).trim();
            }
            await login({ organization: orgId ?? undefined, login_hint: trimmed, prompt: 'login' });
        }
        catch {
            showError(GENERIC_ERROR);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return {
        assetsBaseUrl,
        logoUrl,
        logoColorUrl,
        email,
        setEmail,
        isSubmitting,
        error,
        handleSubmit,
        showErrorModal,
        setShowErrorModal,
        errorModalConfig
    };
}
